import { ArrowDown, ArrowDownIcon, ChevronDown, LocateIcon, MapPinIcon, User2Icon } from "lucide-react";
import React, { useState } from "react";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const topMenuItems = [
    {
      name: "BOOK HOME COLLECTION",
      href: "https://www.lalpathlabs.com/book-a-test/delhi",
    },
    {
      name: "BOOK RADIOLOGY / SCAN",
      href: "https://www.lalpathlabs.com/radiology",
    },
    { name: "DOCTORS", href: "https://www.lalpathlabs.com/doctors" },
    {
      name: "BUSINESS PARTNERSHIP",
      href: "https://www.lalpathlabs.com/business-partnership",
    },
    { name: "ABOUT US", href: "https://www.lalpathlabs.com/about-us" },
    { name: "CAREER", href: "https://www.lalpathlabs.com/career" },
    { name: "BLOGS", href: "https://www.lalpathlabs.com/blog/" },
  ];

  return (
    <header>
      <div className="top-bar d-none d-md-flex justify-content-between align-items-center px-5 py-2">
        <img
          src="https://media.lalpathlabs.com/media/logo.webp"
          alt="Dr Lal PathLabs"
          className="header-logo"
        />
        <div className="d-flex align-items-center gap-3">
          <a
            href="https://www.lalpathlabs.com/investors/investors-inside/annual-report"
            className="top-link"
          >
            Investors
          </a>
          &nbsp;|&nbsp;
          <a
            href="https://www.lalpathlabs.com/company-information"
            className="top-link"
          >
            Contact Us
          </a>
          &nbsp;|&nbsp;
          <a
            href="tel:01149885050"
            className="d-flex align-items-center gap-1 top-link"
          >
            <img
              src="https://media.lalpathlabs.com/media/call.webp"
              alt="Call"
              className="icon-bg"
            />
            011-4988-5050
          </a>
          <a
            href="mailto:customer.care@lalpathlabs.com"
            className="d-flex align-items-center gap-1 top-link"
          >
            <img
              src="https://media.lalpathlabs.com/media/mail.webp"
              alt="Mail"
              className="icon-bg"
            />
            customer.care@lalpathlabs.com
          </a>
        </div>
      </div>

      <nav className="navbar navbar-expand-md navbar-light bg-white shadow-sm">
        <div className="container-fluid px-5">
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <img
              src="https://www.lalpathlabs.com/test/public//assets/img/icons/Side%20menu.svg"
              alt="Menu"
              className="menu-icon"
            />
          </button>

          <div
            className={`collapse navbar-collapse ${
              mobileMenuOpen ? "show" : ""
            }`}
          >
            <ul className="navbar-nav me-auto mb-2 mb-md-0 gap-2">
              {topMenuItems.map((item, i) => (
                <li className="nav-item" key={i}>
                  <a className="nav-link" href={item.href} target="_blank">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>

            <div className="d-flex align-items-center gap-3 header-right">
              <div className="dropdown location-dropdown">
                <button
                  className="btn btn-link d-flex align-items-center"
                  type="button"
                >
                  <span className="location-icon">
                    <img
                      src="https://media.lalpathlabs.com/media/location.png"
                      alt="location"
                      style={{ width: "18px", height: "24px" }}
                    />
                  </span>
                  <span className="location-text">Delhi</span>
                  <ChevronDown size={18} style={{ marginLeft: "74px",color: "#9e9e9e" }} />
                </button>
              </div>

              <div className="dropdown user-dropdown">
                <button
                  className="btn2 btn-link d-flex align-items-center"
                  type="button"
                >
                  <span className="user-icon">
                    <User2Icon size={16} />
                  </span>
                  <span className="user-text">Welcome Guest User</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
